<template>
  <div class="container">
    <div class="meet-level trans">
      <meet-header
        :headerConfig="headerConfig"
        @handleClickIocn="handleClickIocn"
      />

      <div class="main">
        <h2 class="tit" style="margin-bottom: 16px">{{ inform.name }}</h2>
        <div class="details" v-if="inform.file_metadata && inform.file_metadata.length > 0">
          <span>点击文件名下载附件：</span>
          <h2 @click.stop="openfile" class="shadow" style="font-size: 24px;font-weight: bold;">{{
            inform.file_metadata[0].filename
          }}</h2>
        </div>
        <span v-if="inform.file_metadata && inform.file_metadata.length > 0 && this.inform.content.length>0">正文：</span>
        <RichHtml
          style="margin-left: 4px; margin-right: 4px"
          :content="this.inform.content"
        ></RichHtml>
      </div>
    </div>
  </div>
</template>

<script>
  import meetHeader from "@/components/header"
  import RichHtml from "@/components/RichHtml"
  import { ConfInform } from "@/store/entity/conferinfo"

  export default {
    name: "meetLevel",
    components: {
      meetHeader,
      RichHtml,
    },
    data() {
      return {
        headerConfig: {
          headerIcon: "city ct-xiangyou",
          headerTitle: "详细信息",
        },
        inform: {},
      }
    },
    async created() {
      if (this.$route.params.inform) {
        this.inform = this.$route.params.inform
      } else if (this.$route.query.inform_id) {
        this.inform = await ConfInform.get_by_id(this.$route.query.inform_id)
      }
    },
    methods: {
      handleClickIocn() {
        this.$router.go(-1)
        // history.go(-1);
      },
      openfile(){
        const url = this.inform.file_metadata[0].url
        window.open(url)
      }
    },
  }
</script>

<style lang="scss" scoped>
  .main {
    width: 100%;
    padding: 0 15px;
    margin-bottom: 30px;
    box-sizing: border-box;

    .tit {
      padding-left: 8px;
      margin-top: 30px;
      border-left: 4px solid var(--main-color);
      font-size: 18px;
      font-weight: bold;
      color: var(--main-color);
    }

    .details {
      width: 100%;
      margin-top: 30px;
      font-size: 14px;
      padding: 15px;
      line-height: 28px;
      color: #666;
      border-radius: 5px;
      box-sizing: border-box;
    }
  }
</style>
